
if (!customElements.get('recommended-larger-box')) {
  customElements.define(
    'recommended-larger-box',
    class RecommendedLargerBox extends HTMLElement {
      connectedCallback() {
        this.variantMap = {};

        try {
          this.variantMap = JSON.parse(this.querySelector('[data-variant-map]').textContent);
        } catch (error) {
          console.warn('recommended-larger-box: could not parse variant map', error);
        }

        this.onVariantChange = this.onVariantChange.bind(this);
        document.addEventListener('variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this.onVariantChange);
      }

      onVariantChange(event) {
        // product-info dispatches this from its own element, so ignore the other product
        // forms on the page (quick add modal, complementary products, ...)
        if (event.target instanceof Node && !event.target.contains(this)) return;

        const variant = event.detail && event.detail.variant;
        if (!variant) return;

        this.update(variant.id);
      }

      update(variantId) {
        const entry = this.variantMap[variantId];
        if (!entry) return;

        const title = this.querySelector('.recommended-larger-box__title');
        const subtitle = this.querySelector('.recommended-larger-box__subtitle');
        const card = this.querySelector('.recommended-larger-box__card');

        if (title) title.innerHTML = entry.benefit;
        if (subtitle) subtitle.innerHTML = entry.subtitle;
        if (card && entry.url) card.setAttribute('href', entry.url);
      }
    }
  );
}